import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Toast { id: string; message: string; type: 'success' | 'error' | 'info'; }
interface UiState { toasts: Toast[]; sidebarOpen: boolean; }
const initialState: UiState = { toasts: [], sidebarOpen: true };

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    addToast(state, action: PayloadAction<Omit<Toast, 'id'>>) {
      state.toasts.push({ ...action.payload, id: Date.now().toString() });
    },
    removeToast(state, action: PayloadAction<string>) {
      state.toasts = state.toasts.filter((t) => t.id !== action.payload);
    },
    toggleSidebar(state) { state.sidebarOpen = !state.sidebarOpen; },
  },
});

export const { addToast, removeToast, toggleSidebar } = uiSlice.actions;
export default uiSlice.reducer;
export const selectToasts = (s: { ui: UiState }) => s.ui.toasts;
export const selectSidebarOpen = (s: { ui: UiState }) => s.ui.sidebarOpen;
